<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {capitalize} from 'lodash'

import {ApexOptions} from 'apexcharts'

@Component({})
export default class DashboardChartIssuesDonut extends Vue {
  @Prop()
  events: {name: string; count: number}[]

  get chartOptions(): ApexOptions {
    return {
      chart: {
        type: 'donut',
      },
      labels: this.events.map((event) => capitalize(event.name)),
      colors: ['#fd5248', '#ffba01', '#19b7e9'],
      legend: {
        show: false,
      },
      plotOptions: {
        pie: {
          donut: {
            labels: {
              show: true,
              value: {
                show: true,
                fontSize: '18px',
                fontFamily: 'Nunito, sans-serif',
                fontWeight: 800,
                offsetY: -9,
                formatter: (val) => val,
              },
              total: {
                show: true,
                showAlways: true,
                label: '',
                formatter: () => {
                  return this.series.reduce((a, b) => a + b, 0).toString()
                },
              },
            },
          },
        },
      },
    }
  }

  get series() {
    return this.events.map((event) => event.count)
  }
}
</script>
|
<template>
  <apexchart
    v-if="events"
    height="140"
    width="140"
    :options="chartOptions"
    :series="series"></apexchart>
</template>
